import Input from '../ui/Input'
import Button from '../ui/Button'
import { classNames } from '../../lib/classNames'

const KINDS = [
    ['note', 'Notes'],
    ['quicktodo', 'Quick'],
]

export default function NoteToolbar({ activeKind, onKindChange, query, onQueryChange, onNew, onImport, selectMode, selectedCount, onToggleSelectMode }) {
    return (
        <div className="mt-5 flex flex-col gap-3">
            <div className="flex gap-2">
                {KINDS.map(([key, label]) => (
                    <button
                        key={key}
                        onClick={() => onKindChange(key)}
                        className={classNames(
                            'px-4 py-1.5 border-2 text-sm font-semibold uppercase tracking-wide transition-colors',
                            activeKind === key
                                ? 'bg-black text-white border-black dark:bg-white dark:text-black dark:border-white'
                                : 'bg-white text-black border-black dark:bg-zinc-950 dark:text-white dark:border-white hover:bg-accent hover:text-black hover:border-accent'
                        )}
                    >
                        {label}
                    </button>
                ))}
            </div>

            {activeKind !== 'quicktodo' && (
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <Input
                        value={query}
                        onChange={(e) => onQueryChange(e.target.value)}
                        placeholder="Search notes..."
                        className="w-full sm:w-1/2"
                        aria-label="Search notes"
                    />
                    <div className="flex items-center gap-2">
                        <Button variant={selectMode ? 'primary' : 'secondary'} onClick={onToggleSelectMode}>
                            {selectMode ? `Exit Select (${selectedCount})` : 'Select'}
                        </Button>
                        <Button variant="secondary" onClick={onImport}>
                            Import lines → notes
                        </Button>
                        <Button onClick={onNew}>+ New note</Button>
                    </div>
                </div>
            )}
        </div>
    )
}
